// Consulta periódica que respeta la pestaña: no corre si está oculta, se pone al día al volver
// y agrega una variación aleatoria para que cientos de usuarios no pidan todos en el mismo segundo.
export const visiblePoll = (fn, ms) => {
  let timer = null;
  let last = Date.now();
  const jitter = () => ms * (0.85 + Math.random() * 0.3);
  const tick = () => {
    if (document.visibilityState === 'visible') { last = Date.now(); try { fn(); } catch (e) { /* silencioso */ } }
    timer = setTimeout(tick, jitter());
  };
  const onVisible = () => {
    if (document.visibilityState === 'visible' && Date.now() - last > ms) { last = Date.now(); try { fn(); } catch (e) { /* silencioso */ } }
  };
  document.addEventListener('visibilitychange', onVisible);
  timer = setTimeout(tick, jitter());
  return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', onVisible); };
};
